import {AccessorsMutatorsDecorator, Model} from '../../helpers';

export class NTMPFinancialSetting extends Model {}

AccessorsMutatorsDecorator(
    'id',
    'integration_key',
    'integration_secret',
    'is_active'
)(NTMPFinancialSetting);

export class NTMPFinanceFacilitySetting extends Model {}

AccessorsMutatorsDecorator(
    'id',
    'property_id',
    'facility_id',
    'facility_secret',
    'is_active'
)(NTMPFinanceFacilitySetting);



// WEBPACK FOOTER //
// ./src/pms-api/models/ntmp-financial-setting.model.js